import React from 'react'
import Header from '../Layout/Header'
import Lorem from '../Home/HomeSections/Lorem'
import Footer from '../Layout/Footer'
import HelpBanner from './HelpBanner'
import Testimonials from '../Home/HomeSections/Testimonials'
import FAQs from '../Pricing/PricingSections/FAQs'

export default function Help() {
  return (
    <div>
        <Header/>
        <HelpBanner/>
        <FAQs/>
        <Testimonials/>
        <Lorem/>
        <Footer/>
    </div>
  )
}
